/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_Unknown_PlayerInputs */



/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Rankings_Unknown_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_unknown_player = /** @type {((inputs?: Rankings_Unknown_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Unknown_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inconnu")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desconocido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desconhecido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sconosciuto")
	return /** @type {LocalizedString} */ ("Unknown")
});